const isDev = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname.indexOf('dev.') >= 0) return true;
    return false;
}

export default isDev;
